import { NitrogenDeliveryRate } from './models';

export const nitrogenDeliveryRates: NitrogenDeliveryRate[] = [
  {
    isLeguminous: false,
    successRate: 100,
    autumnNitrogenDeliveryAmount: 30,
    springNitrogenDeliveryAmount: 40,
  },
  {
    isLeguminous: false,
    successRate: 75,
    autumnNitrogenDeliveryAmount: 22,
    springNitrogenDeliveryAmount: 30,
  },
  {
    isLeguminous: false,
    successRate: 50,
    autumnNitrogenDeliveryAmount: 15,
    springNitrogenDeliveryAmount: 20,
  },
  {
    isLeguminous: true,
    successRate: 100,
    autumnNitrogenDeliveryAmount: 60,
    springNitrogenDeliveryAmount: 60,
  },
  {
    isLeguminous: true,
    successRate: 75,
    autumnNitrogenDeliveryAmount: 45,
    springNitrogenDeliveryAmount: 45,
  },
  {
    isLeguminous: true,
    successRate: 50,
    autumnNitrogenDeliveryAmount: 30,
    springNitrogenDeliveryAmount: 30,
  },
];
